import { styled, css } from 'styled-components';

import { breakpointLargeTablet } from 'src/styles/breakpoints';
import { placeholder } from 'src/styles/mixins';

const centeredPlaceholdersStyles = css`
  margin-left: auto;
  margin-right: auto;

  @media (min-width: ${breakpointLargeTablet}) {
    margin-left: 0;
    margin-right: 0;
  }
`;

export const StyledContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.paragraphPlaceholder.container.marginBottom};
`;

export const StyledTitle = styled.div`
  ${placeholder};
  border-radius: 4px;
  margin-bottom: ${({ theme }) => theme.paragraphPlaceholder.title.marginBottom};
  height: ${({ theme }) => theme.paragraphPlaceholder.title.height};
  max-width: ${({ theme }) => theme.paragraphPlaceholder.title.width};
  ${({ theme }) => theme.paragraphPlaceholder.container.centeredOnMobile && centeredPlaceholdersStyles};
`;

export const StyledParagraphLine = styled.div`
  ${placeholder};
  height: 16px;
  border-radius: 4px;
  max-width: ${({ theme }) => theme.paragraphPlaceholder.paragraph.width};
  ${({ theme }) => theme.paragraphPlaceholder.container.centeredOnMobile && centeredPlaceholdersStyles};

  &:not(:first-child) {
    margin-top: ${({ theme }) => theme.paragraphPlaceholder.paragraph.spaceBetweenLines};
  }
`;
